import Image from 'global/Image';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import { CATEGORIES_ID, EMOJI_LIST_ID, EMOJI_PICKER_CATEGORY, WORDING_NO_RECENT_EMOJI } from './constants';
import {
  EmojiCategoryItem,
  EmojiHeaderContainer,
  EmojiPickerWrapper,
  EmojiCategoryContainer,
  SearchInput,
  EmojiListContainer,
  EmojiListSection,
  EmojiItem,
  NoRecentEmoji,
} from './styled';
import useEmojiPicker from './useEmojiPicker';

interface EmojiPickerProps {
  onSelectEmoji: (emoji: string) => void;
  // eslint-disable-next-line react/no-unused-prop-types
  children?: any;
}

function EmojiPicker({
  onSelectEmoji,
}: EmojiPickerProps) {
  const {
    listEmoji,
    recentListEmoji,
    activeIndexCategory,
    handleClickCategory,
    handleSelectEmoji,
    handleScrollEmojiList,
    onChangeKeyword,
  } = useEmojiPicker();

  const handleClickEmoji = (emoji) => {
    handleSelectEmoji(emoji);
    onSelectEmoji(emoji);
  };

  return (
    <EmojiPickerWrapper>
      <EmojiHeaderContainer>
        <EmojiCategoryContainer>
          {EMOJI_PICKER_CATEGORY.map((category, index) => {
            const emojiIconAffix = index === activeIndexCategory
              ? `${category}-active`
              : category;

            const categoryClassName = index === activeIndexCategory
              ? 'active-category'
              : '';

            return (
              <EmojiCategoryItem
                onClick={() => handleClickCategory(category)}
                className={categoryClassName}
                title={category}
              >
                <Image
                  src={`/icon/compose-emoji-${emojiIconAffix}.svg`}
                  style={{ width: '20px', height: '20px' }}
                />
              </EmojiCategoryItem>
            );
          })}
        </EmojiCategoryContainer>
        <SearchInput
          placeholder="Search Emoji"
          width="100%"
          height="35px"
          // @ts-expect-error
          my="16px"
          p="4px"
          onChange={(e) => onChangeKeyword(e.target.value)}
        />
      </EmojiHeaderContainer>
      <EmojiListContainer id={EMOJI_LIST_ID} onScroll={handleScrollEmojiList}>
        <section
          className={`${CATEGORIES_ID.FREQUENT}`}
          id={`section-${CATEGORIES_ID.FREQUENT}`}
        >
          {recentListEmoji.length > 0 ? (
            <>
              {/* @ts-expect-error */}
              <Text color={color.midgray} mb="16px">
                Frequent
              </Text>
              {recentListEmoji.map((emoji) => (
                <EmojiItem
                  key={`emoji-${emoji}`}
                  onClick={() => handleClickEmoji(emoji)}
                >
                  <span role="img">{emoji}</span>
                </EmojiItem>
              ))}
            </>
          ) : (
            <NoRecentEmoji>
              <Text size="13px" color={color.highgray}>
                {WORDING_NO_RECENT_EMOJI}
              </Text>
            </NoRecentEmoji>
          )}
        </section>
        {listEmoji.map((category) => (
          <EmojiListSection
            className={`${category.id ? category.id : 'result'}`}
            id={`section-${category.id ? category.id : 'result'}`}
            key={category.id ? category.id : 'result'}
          >
            {category.id && (
            // @ts-expect-error
            <Text color={color.midgray} mb="16px">
              {category.id}
            </Text>
            )}
            {category.emojis.map((emoji) => (
              <EmojiItem
                key={`emoji-${emoji}`}
                onClick={() => handleClickEmoji(emoji)}
              >
                <span role="img">{emoji}</span>
              </EmojiItem>
            ))}
          </EmojiListSection>
        ))}
      </EmojiListContainer>

    </EmojiPickerWrapper>
  );
}

export default EmojiPicker;
